import React from 'react';
import { observer } from 'mobx-react';
import {
  Box, Card, CardContent,
} from '@mui/material';
import { ReferralsAnalytics } from '@gamiphy/loyalty-station-desktop/store/analytics';
import { ReferralsStore } from '@gamiphy/loyalty-station-desktop/store/refferals';
import InviteFriend from './components/InviteFriends';
import InviteOptionsPopup from './components/InviteOptionsPopup';

const Circles = observer(() => {
  const [inviteCard, setInviteCard] = React.useState(false);
  const onChangeState = () => {
    ReferralsAnalytics.trackInviteClicked();

    setInviteCard(!inviteCard);
  };

  return (
    <Box>
      <Card sx={{
        minHeight: '18rem',
        maxHeight: '40rem',
        boxShadow: 'none',
        borderRadius: 0,
      }}
      >
        <CardContent sx={{
          p: 0,
          '&:last-child': {
            paddingBottom: '0',
          },
        }}
        >
          {ReferralsStore.appReferral && (
            <InviteOptionsPopup
              onChangeState={onChangeState}
              open={inviteCard}
              appReferral={ReferralsStore.appReferral}
              linkReferral={ReferralsStore.linkReferral}
            />
          )}
          <InviteFriend onInvite={onChangeState} />
        </CardContent>
      </Card>
    </Box>
  );
});

export default Circles;
